import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiFetch } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const refetchUser = useCallback(async () => {
    const res = await apiFetch("me.php");
    setUsuario(res.ok ? res.data : null);
    return res;
  }, []);

  // Ao montar o app, pergunta pra API se já existe uma sessão válida
  useEffect(() => {
    (async () => {
      setCarregando(true);
      await refetchUser();
      setCarregando(false);
    })();
  }, [refetchUser]);

  const login = async (email, senha) => {
    const res = await apiFetch("login.php", {
      method: "POST",
      body: JSON.stringify({ email, senha }),
    });
    if (res.ok) {
      setUsuario(res.data);
    }
    return res;
  };

  const cadastrar = async (dadosCadastro) => {
    const res = await apiFetch("cadastro.php", {
      method: "POST",
      body: JSON.stringify(dadosCadastro),
    });
    return res;
  };

  const logout = async () => {
    await apiFetch("logout.php", { method: "POST" });
    setUsuario(null);
  };

  return (
    <AuthContext.Provider
      value={{ usuario, carregando, login, cadastrar, logout, refetchUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth precisa ser usado dentro de um <AuthProvider>");
  }
  return context;
}
